import { LinkTwoTone } from "@mui/icons-material";
import { Link } from "@mui/material";
import React, { useEffect, useId, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

import Modal from "../../components/Modal";
import Button from "../Button";
import Card from "../Card";
import EmailInput from "../Form/EmailInput";
import PasswordInput from "../Form/PasswordInput";

import useUserStore from "../../store/User.store";

import "./signinCard.scss";


const SignInCard = (props) => {
  const handleSignIn = useUserStore((state) => state.actions.handleSignIn);

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [disableButton, setDisableButton] = useState(true);

  const methods = useForm({
    mode: "onTouched",
  });
  const loginEmailValue = methods.watch("loginEmail");
  const loginPasswordValue = methods.watch("loginPassword");

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const handleSubmitLogin = async (data) => {
    setDisableButton(true);
    const res = await handleSignIn(data);
    if (res.responseCode === 200) {
      navigate(from, { replace: true });
    } else if (res.responseCode === 302 && res.route) {
      navigate(res.route);
    } else {
      setShowErrorModal(true);
    }
  };

  useEffect(() => {
    if (loginEmailValue && loginPasswordValue) {
      setDisableButton(false);
    }
  }, [loginEmailValue, loginPasswordValue]);

  const id = useId();

  return (
    <>
      <FormProvider {...methods}>
        <Card
          {...props}
          id={id}
          className="card--login"
          title="Sign In"
          description="Sign in using your company email address."
          collapsible={false}
          openByDefault={true}
        >
          <div className="card__content">
            <form
              className="login-form"
              onSubmit={methods.handleSubmit(handleSubmitLogin)}
            >
              <EmailInput name={"loginEmail"} label={"Email"} />

              <PasswordInput name={"loginPassword"} label={"Password"} />

              <Button
                size="medium"
                disabled={disableButton || methods.formState.errors.loginEmail}
                className="login-submit-button"
              >
                Sign In
              </Button>
            </form>
          </div>
          <div className="card__footer">
            <Link
              className="remi-connect"
              href="https://cloud.mail.allspringglobal.com/remi-connect?_gl=1*1k19p8a*_gcl_au*ODk2MTMyMTg5LjE2OTE1MDExNTI."
              target="_blank"
              rel="noopener"
            >
              <LinkTwoTone />
              Ready to meet Remi? | Allspring Global Investments
            </Link>
          </div>
        </Card>
      </FormProvider>
      <Modal
        show={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        heading="Error Signing In"
        subtitle="Incorrect User or Password"
        cancelButton={{
          variant: "outline",
          children: "Retry Login",
        }}
      />
    </>
  );
};

export default SignInCard;
